import { LangConstant } from "const";
import React from "react";
import { useTranslation } from "react-i18next";

const NoData = ({ content, ...otherProps }) => {
  const { t: getLabel } = useTranslation(LangConstant.NS_COMMON);

  return (
    <div className="d-flex justify-content-center align-items-center flex-grow-1" {...otherProps}>
      <span className="text-secondary" style={{ fontSize: "16px" }}>
        {content || getLabel(LangConstant.TXT_NOT_FOUND)}
      </span>
    </div>
  );
};

export default NoData;
